import { render, staticRenderFns } from "./RegisterSubModule.vue?vue&type=template&id=986cb7d2&scoped=true&"
import script from "./RegisterSubModule.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModule.vue?vue&type=style&index=0&id=986cb7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986cb7d2",
  null
  
)

export default component.exports